import React, { Component } from "react";
import Steps from "./Steps";
import Input from "./../../../../shared/Input/Input";
import { brandFromNumber } from "../../../shared/credit-card-util";
import { isAllFieldsEmpty, getUserToken, validCreditCardDate } from "../../../shared/utils";
import Checkbox from "./../../../../shared/Checkbox/Checkbox";
import { sendCreateUpdateCreditCard } from "../../../shared/requests-api";
import Modal from "../../../../shared/Modal/Modal";
import { validateCPF } from "../../../../../js/shared/validation-utils";
import { validateCNPJ } from "../../../shared/utils";

class RegisterCreditCard extends Component {
	constructor() {
		super();
		this.state = {
			errors: {
				name: undefined,
				cpf: undefined,
				securityCode: undefined,
				validDate: undefined,
				number: undefined,
				bypass: true
			},
			notInform: false
		};

		this.submitAndNextStep = this.submitAndNextStep.bind(this);
		this.saveAndPrevStep = this.saveAndPrevStep.bind(this);
		this.validForm = this.validForm.bind(this);
		this.confirmNextStep = this.confirmNextStep.bind(this);
	}

	componentDidMount() {
		const { form } = this.props;

		if (form) {
			form.bypass = true;
			this.setState(form);
		}
	}

	submitAndNextStep() {
		const token = getUserToken();
		const { name, number, validDate, securityCode, cpf, notInform, bypass } = this.state;
		let self = this;

		if (notInform || bypass) {
			self.props.next(self.state);
		} else {
			let numberFmt = String(number).replace(/[^0-9.]/g, "");

			self.setState({ loadingMessage: "Estamos salvando os dados..." });
			sendCreateUpdateCreditCard(token, name, numberFmt, validDate, String(securityCode), cpf)
				.then(response => {
					self.props.next(self.state);
				})
				.catch(response => {
					console.log(response);
					self.setState({ loadingMessage: response.data.message });
				});
		}
	}

	saveAndPrevStep() {
		this.props.prev(this.state);
	}

	validForm(event) {
		const { errors } = this.state;
		let value = event.target.type == "checkbox" ? event.target.checked : event.target.value;

		if (event.target.name == "name") {
			value = value.replace(/[0-9]/g, "");
		}

		errors[event.target.name] = value
			? ""
			: `${event.target.title || event.target.name} não confere`;

		if (event.target.name == "cpf" && event.target.value) {
			let length = event.target.value.length;
			let isCPFValid = validateCPF(event.target.value);
			let isCNPJValid = validateCNPJ(event.target.value);
			if (length < 14) {
				errors.cpf = "CPF inválido";
			} else if (length == 14 && isCPFValid == false) {
				errors.cpf = "CPF inválido";
			} else if (length > 14 && length < 18) {
				errors.cpf = "CNPJ inválido";
			} else if (length == 18 && isCNPJValid == false) {
				errors.cpf = "CNPJ inválido";
			}
		}

		if (event.target.name == "number") {
			value = value.replace(/\D/g, "");
		}

		if (event.target.name == "notInform") {
			errors.notInform = "";
		}

		if (event.target.name == "securityCode") {
			if (event.target.value.length < 3) {
				errors.securityCode = "Código de segurança inválido.";
			}
		}

		if (event.target.name == "validDate") {
			if (validCreditCardDate(event.target.value)) {
				errors.validDate = "";
			} else {
				errors.validDate = "Data inválida";
			}
		}

		this.setState({ [event.target.name]: value, errors, bypass: false });
	}

	isValid = () => {
		const { name, cpf, securityCode, validDate, number, errors, notInform, bypass } = this.state;

		return (
			(name &&
				cpf &&
				securityCode &&
				validDate &&
				number &&
				isAllFieldsEmpty(errors, "name", "cpf", "securityCode", "validDate", "number")) ||
			notInform ||
			bypass
		);
	};

	searchBrand = num => {
		let card = brandFromNumber(num);
		this.setState({ card });
	};

	confirmNextStep() {
		const { card, name, cpf, securityCode, validDate, number, errors, notInform } = this.state;

		if (!this.isValid()) {
			if (card == "" || card == undefined) {
				errors.card = "Campo obrigatório";
			}
			if (name == "" || name == undefined) {
				errors.name = "Campo obrigatório";
			}
			if (cpf == "" || cpf == undefined) {
				errors.cpf = "Campo obrigatório";
			}
			if (securityCode == "" || securityCode == undefined) {
				errors.securityCode = "Campo obrigatório";
			}
			if (validDate == "" || validDate == undefined) {
				errors.validDate = "Campo obrigatório";
			}
			if (number == "" || number == undefined) {
				errors.number = "Campo obrigatório";
			}
			this.setState({ errors });
		} else {
			this.submitAndNextStep();
		}
	}

	render() {
		const { prev } = this.props;
		const {
			card,
			name,
			cpf,
			securityCode,
			validDate,
			number,
			errors,
			notInform,
			loadingMessage,
			showLoading
		} = this.state;

		let optionNotInform = [
			{
				label: "Não desejo informar meu cartão de crédito",
				name: "notInform",
				checked: notInform
			}
		];

		return (
			<section className="credit-card-details row no-margin">
				<form className="form-offer block-center" onChange={this.validForm}>
					<div className="col-xs-16 text-center">
						<span className="form-offer--title">
							Cartão de Crédito
							<span className="form-offer--title--subtitle hidden-xs">
								Faça o cadastro do seu cartão de crédito e garanta que suas milhas sejam vendidas
								com mais rapidez e segurança. Fique tranquilo, só usaremos o seu cartão para pagar
								as taxas de embarque e/ou bagagem. Junto com o pagamento das suas milhas, faremos o
								reembolso deste valor a você.
							</span>
						</span>
					</div>
					<div className="row">
						<div className="col-xs-16 col-md-7">
							<Input
								label="Nome do titular"
								placeholder="Nome do titular"
								name="name"
								value={name}
								disabled={notInform}
								errorMessage={errors.name}
								required
								className="holder-name"
								data-action="register-credit-card-name"
							/>
						</div>
						<div className="col-xs-16 col-md-5">
							<Input
								label="CPF/CNPJ"
								placeholder="Insira seu CPF ou CNPJ"
								maskpattern={["999.999.999-999", "99.999.999/9999-99"]}
								name="cpf"
								value={cpf}
								pattern="\d*"
								inputMode="numeric"
								disabled={notInform}
								errorMessage={errors.cpf}
								required
								data-action="register-credit-card-cpfcnpj"
							/>
						</div>
						<div className="col-xs-16 col-md-7">
							<Input
								label="Número do cartão"
								placeholder="Inserir número do cartão"
								maskpattern="9999 9999 9999 9999"
								name="number"
								required
								value={number}
								pattern="\d*"
								inputMode="numeric"
								disabled={notInform}
								onChange={this.searchBrand}
								maskpattern={card && card.mask}
								errorMessage={errors.number}
								data-action="register-credit-card-number"
							>
								{card && (
									<div
										className={`form-control-feedback cc-img cc-${card.brand}`}
										title={`Cartão ${card.brand}`}
									/>
								)}
							</Input>
						</div>
						<div className="col-xs-16 col-sm-8 col-md-3">
							<Input
								label="Data de Validade"
								placeholder="  /  "
								maskpattern="99/99"
								name="validDate"
								value={validDate}
								pattern="\d*"
								inputMode="numeric"
								errorMessage={errors.validDate}
								disabled={notInform}
								required
								data-action="register-credit-card-valid-date"
							/>
						</div>
						<div className="col-xs-16 col-sm-8 col-md-2">
							<Input
								label="CVC"
								placeholder=""
								name="securityCode"
								value={securityCode}
								pattern="\d*"
								inputMode="numeric"
								minLength="3"
								maxLength={card ? card.cvcLength[0] : 4}
								maskpattern="9999"
								errorMessage={errors.securityCode}
								disabled={notInform}
								required
								data-action="register-credit-card-security-code"
							/>
						</div>
						<div className="col-xs-16 visible-xs">
							<p>
								Faça o cadastro do seu cartão de crédito e garanta que suas milhas sejam vendidas
								com mais rapidez e segurança. Fique tranquilo, só usaremos o seu cartão para pagar
								as taxas de embarque e/ou bagagem. Junto com o pagamento das suas milhas, faremos o
								reembolso deste valor a você.
							</p>
						</div>
						<div className="col-xs-16 not-inform">
							<Checkbox
								id="notInform"
								name="notInform"
								onChange={options => this.setState({ notInform: options })}
								options={optionNotInform}
								data-action="register-credit-card-not-inform-checkbox"
							/>
						</div>
					</div>
				</form>

				<Steps
					prev={this.saveAndPrevStep}
					next={this.confirmNextStep}
					canPrev={true}
					canNext={true}
				/>

				<Modal
					title="CARTÃO DE CRÉDITO"
					description={loadingMessage}
					show={showLoading}
					confirm="Fechar"
					onConfirm={() => this.setState({ showLoading: false })}
				/>
			</section>
		);
	}
}

export default RegisterCreditCard;
